import gql from "graphql-tag";

export const GET_SYSTEM_CONFIG_QUERY = gql`
  query GetSystemConfig {
    getSystemConfig {
      message
    }
  }
`;
